import React from 'react';
import styled from 'styled-components';
import corporateContentData from '../../content/corporateContentData';

const VisuallyHiddenSection = styled.section`
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  border: 0;
  white-space: nowrap;
`;

const renderHTML = (html) => ({ __html: html });

const SEOContent = () => (
  <VisuallyHiddenSection aria-label="New Work City overview">
    <h1>New Work City</h1>
    <p>
      New Work City works at the intersection of brand, culture, and creative technology.
      We exist to radically reimagine the way brands are built, told, and experienced.
    </p>
    <p>
      From Subiaco, Perth we partner with founders, CMOs, and cultural leaders who want
      to prototype braver narratives, immersive experiences, and future-facing products.
      Every engagement blends rigorous strategy with creative technology, delivering
      ideas that travel across channels, cities, and screens.
    </p>

    {corporateContentData.sections.map((section) => {
      if (section.type === 'values') {
        return (
          <section key={section.id}>
            <h2>{section.title}</h2>
            <ol>
              {section.items.map((item, index) => (
                <li key={`${item.title}-${index}`}>
                  <strong>{item.title}.</strong>{' '}
                  <span dangerouslySetInnerHTML={renderHTML(item.description)} />
                </li>
              ))}
            </ol>
          </section>
        );
      }

      if (section.type === 'services') {
        return (
          <section key={section.id}>
            <h2>{section.title}</h2>
            {section.categories.map((category) => (
              <article key={category.title}>
                <h3>{category.title}</h3>
                {category.paragraphs.map((paragraph, index) => (
                  <p key={`${category.title}-paragraph-${index}`} dangerouslySetInnerHTML={renderHTML(paragraph)} />
                ))}
                <ul>
                  {category.services.map((service) => (
                    <li key={`${category.title}-service-${service}`}>{service}</li>
                  ))}
                </ul>
              </article>
            ))}
          </section>
        );
      }

      if (section.type === 'contact') {
        return (
          <section key={section.id}>
            <h2>{section.title}</h2>
            <p>{section.seoContactCopy}</p>
            <address>
              Hay Street<br />
              Subiaco WA 6008<br />
              Australia
            </address>
            <p>
              Email <a href="mailto:SAYHELLO@NW.CITY">SAYHELLO@NW.CITY</a> for briefs, invites, or civilian
              sightings.
            </p>
          </section>
        );
      }

      return (
        <section key={section.id}>
          <h2>{section.title}</h2>
          {section.contentBlocks?.map((block, index) => {
            if (block.type === 'paragraph') {
              return <p key={`${section.id}-paragraph-${index}`} dangerouslySetInnerHTML={renderHTML(block.html)} />;
            }

            if (block.type === 'contentHeading') {
              return <h3 key={`${section.id}-heading-${index}`} dangerouslySetInnerHTML={renderHTML(block.html)} />;
            }

            return null;
          })}
        </section>
      );
    })}
  </VisuallyHiddenSection>
);

export default SEOContent;

